import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LoadingFade from "../../LoadingFade";
import {useState, useEffect, createRef} from "react";
import {useNavigate, useParams} from "react-router-dom";
import httpService from "../../../services/httpService";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import EpisodeSelectCard from "../EpisodeSelectCard";
import {Modal} from "react-bootstrap";
import Card from 'react-bootstrap/Card';
import Heading3 from "../../Heading3";
import SkillButton from "../SkillButton";
import AudioPlayer from "../../AudioPlayer";
import EpisodeEditCardList from "../EpisodeEditCardList";
import ScheduleCalendar from "../ScheduleCalendar";
import { FaSpinner } from "react-icons/fa6";
import { useUiStore } from "../../../store/store";

const newSkillTemplate = {
    "title" : "",
    "description" : ""
};
const StepScheduleEpisodes = ({onStageChange, onClubChange, podcastClub}) => {
    const navigate = useNavigate();
    const { step, id } = useParams();
    const { setShowPodcasterPodcastClubOnboardingVideo } = useUiStore();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [clubEpisodes, setClubEpisodes] = useState([]);
    const [show, setShow] = useState(false);
    const [isWizardCompleted, setIsWizardCompleted] = useState(false);
    const [showVideoModal, setShowVideoModal] = useState(false);

    const getNextMonday = (fromDate) => {
        const date = new Date(fromDate);
        const day = date.getDay();
        // Calculate days until next Monday (1 = Monday)
        // If it's already Monday, use that date
        const daysUntilMonday = day === 1 ? 0 : day === 0 ? 1 : 8 - day;
        date.setDate(date.getDate() + daysUntilMonday);
        return date;
    };

    useEffect(() => {
        // Example: fetching the authenticated user's info
        setLoading(true);
        let endpoint_with_params = "/dash/wizard/get-step/5"+ (id ? "/"+id : "") + (!id && podcastClub ? "/"+podcastClub.guid : '')
        httpService.get(endpoint_with_params)
            .then((res) => {
                const episodes = (res.data.club_episodes || []).map(ep => ({
                    ...ep,
                    start_date_time: ep.pivot?.start_date_time || null,
                }));

                // Check if episodes don't have start dates set, then set them to consecutive Mondays
                if (episodes.length > 0 && !episodes[0].start_date_time) {
                    // Get next Monday from today
                    const firstMonday = getNextMonday(new Date());
                    firstMonday.setHours(8, 0, 0, 0);

                    // Set all episodes to consecutive Mondays
                    const updatedEpisodes = episodes.map((ep, index) => {
                        const episodeDate = new Date(firstMonday);
                        episodeDate.setDate(episodeDate.getDate() + (index * 7));
                        return {
                            ...ep,
                            start_date_time: episodeDate.toISOString().slice(0, 16)
                        };
                    });

                    setClubEpisodes(updatedEpisodes);
                } else {
                    setClubEpisodes(episodes);
                }

                setIsWizardCompleted(res.data.is_wizard_completed)
            })
            .catch((err) => {
                setErrorMessage(err.response?.data?.message || "Error loading data");
            }).finally(() => {
                console.log(podcastClub)
                setLoading(false);
                setPageLoading(false)
            });
    }, []);

    const handleShow = () => {
        setShow(true)
    };

    const handleEpisodeUpdate = async (episodeId, field, value) => {
        setClubEpisodes(prevEpisodes =>
            prevEpisodes.map(ep =>
                ep.id === episodeId ? { ...ep, [field]: value } : ep
            )
        );
    };

    const saveEpisodes = async () => {
        setSaving(true);
        try {
            await httpService.post("dash/wizard/podcast-club/update-all-episodes", {
                episode_pivots: clubEpisodes,
                podcast_club_guid: id
            });
            // onStageChange(5)
            setShowPodcasterPodcastClubOnboardingVideo(true);
            navigate(`/podcaster/podcast-club/${id}`)
        } catch (err) {
            setErrorMessage(err.response?.data?.message || "Error updating episode");
        } finally {
            setSaving(false);
        }
    }

    const saveAndGoToDashboard = async () => {
        setSaving(true);
        setPageLoading(true);
        console.log('saveAndGoToDashboard')
        try {
            await httpService.post("dash/wizard/podcast-club/update-all-episodes", {
                episode_pivots: clubEpisodes,
                podcast_club_guid: id
            });
            //here
            navigate(`/podcaster/podcast-club/${id}`)
        } catch (err) {
            setErrorMessage(err.response?.data?.message || "Error updating episode");
            setSaving(false);
            setPageLoading(false);
        } finally {
            setSaving(false);
            setPageLoading(false);
        }
    }

    const isScheduleValid = () => {
        // Check if there are any episodes
        if (clubEpisodes.length === 0) return false;

        // Check each episode has valid start date
        for (const episode of clubEpisodes) {
            // Check if start date exists
            if (!episode.start_date_time) {
                return false;
            }

            // Check if start date is valid
            const startDate = new Date(episode.start_date_time);
            if (isNaN(startDate.getTime())) {
                return false;
            }
        }

        return true;
    };

    return(
        <LoadingFade loading={loading} stateKey={loading?'loading':'not-loading'}>
            <Row>
                <Col sm={12}>
                    <h3>Schedule your club</h3>
                    <p>
                        By default, episodes run weekly on Mondays. Drag an episode to a different week to change its release date, tap an episode to adjust the time. &nbsp;<a onClick={() => setShowVideoModal(true)} className={"text-secondary collapse-info"} style={{cursor: 'pointer'}}>watch video</a>
                    </p>
                </Col>
            </Row>

            <Row className="mb-4">
                <Col xs={12} className="mb-4">
                    <h5 className="mb-3">Calendar Overview</h5>
                    <p className="text-muted">Drag an episode to a different week to change its release date. Tap an episode to adjust the time. Numbers show the release order.</p>
                    <ScheduleCalendar
                        episodes={clubEpisodes}
                        onEpisodeUpdate={handleEpisodeUpdate}
                    />
                </Col>
            </Row>

            <Row>
                <Col sm={4} className={'mb-3'}>
                    <label className={'mb-2'}>Go to key takeaways selection</label>
                    <button
                        className={"btn btn-light btn-block w-100"}
                        onClick={() => onStageChange(5, id)}
                    >
                        Back
                    </button>
                </Col>
                <Col sm={4} className={'mb-3'}>
                    {/*<Button*/}
                    {/*    onClick={saveEpisodes}*/}
                    {/*    className="w-100"*/}
                    {/*    variant="primary"*/}
                    {/*    disabled={!isScheduleValid()}*/}
                    {/*>*/}
                    {/*    Save*/}
                    {/*</Button>*/}
                </Col>
                <Col sm={4} className={"mb-3"}>
                    <label className={'mb-2'}>Finish setup</label>
                    <Button
                        onClick={isWizardCompleted ? saveAndGoToDashboard : saveEpisodes}
                        className="w-100"
                        variant="primary"
                        disabled={saving || !isScheduleValid()}
                    >
                        {saving ? <FaSpinner className="loading_spinner" /> : (isWizardCompleted ? 'Go back to podcast dashboard' : 'Continue')}
                    </Button>
                </Col>
            </Row>

            <Modal show={showVideoModal} onHide={() => setShowVideoModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Schedule your club</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{position: 'relative', paddingBottom: '56.25%', height: 0}}>
                        <iframe
                            src="https://www.loom.com/embed/fd7360bb8f1b4a2ea1147e93eece1d44"
                            frameBorder="0"
                            webkitallowfullscreen="true"
                            mozallowfullscreen="true"
                            allowFullScreen
                            style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </LoadingFade>
    )
}

export default StepScheduleEpisodes;